import axios from 'api/axiosInstances/axiosInstance';

export const retrieveUserBillingAccounts = () => {
  return axios.get(`/users/billingaccounts`);
};
